<template>
  <div class="as-schematic-info">
    <div class="as-d-inline-flex">
      <div class="as-schematic-info__imgNull"></div>
    </div>

    <div class="as-schematic-info__name">-</div>
  </div>
  <div class="as-schematic-score">
    <span>-</span>
  </div>
</template>

<script lang="ts">
export default {};
</script>
